// Sable & Ochre — Theme JS

(function () {
  'use strict';

  // Cart count refresh after add-to-cart
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('#product-form');
    if (!form) return;
    e.preventDefault();

    var btn = form.querySelector('#add-to-cart-btn');
    var variantId = form.querySelector('[name="id"]').value;
    // Keep the button's own nodes. product-template.liquid's variant script holds references to its spans
    // (#btn-price, #btn-what); restoring a saved innerHTML string swapped them for copies, so after one add
    // the button stopped following size and format changes (2026-10-01).
    var kept = btn ? Array.prototype.slice.call(btn.childNodes) : [];
    function restore() {
      if (!btn) return;
      btn.textContent = '';
      kept.forEach(function (n) { btn.appendChild(n); });
      btn.disabled = false;
    }

    if (btn) {
      btn.textContent = 'Adding…';
      btn.disabled = true;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (res) { return res.json(); })
      .then(function () {
        return fetch('/cart.js');
      })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var countEl = document.getElementById('cart-count');
        if (countEl) {
          countEl.textContent = cart.item_count;
          countEl.classList.add('pop');
          setTimeout(function () { countEl.classList.remove('pop'); }, 400);
        }
        if (btn) {
          btn.textContent = '✓ Added!';
          setTimeout(restore, 1800);
        }
      })
      .catch(function () {
        restore();
      });
  });

  // Tables come from merchant content (product descriptions, page bodies), so
  // the theme cannot wrap them in Liquid. Without a scroll container a wide
  // shipping or pricing table runs off the edge of a phone screen.
  document.querySelectorAll('.salon-article table, .mw-product-description table').forEach(function (table) {
    if (table.parentElement && table.parentElement.classList.contains('salon-tablewrap')) return;
    var wrap = document.createElement('div');
    wrap.className = 'salon-tablewrap';
    wrap.setAttribute('tabindex', '0');
    wrap.setAttribute('role', 'group');
    var caption = table.querySelector('caption');
    wrap.setAttribute('aria-label', caption ? caption.textContent.trim() : 'Table');
    table.parentNode.insertBefore(wrap, table);
    wrap.appendChild(table);
  });

  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var target = document.querySelector(a.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

})();
